import { Card, Col, Row, Skeleton, Statistic, Table } from 'antd'
import dayjs from 'dayjs'
import { centsToDollarsDisplay } from '../../displayFormatters'
import { useGetProposalsReport } from './queries'
import { roundToPrecision } from '../../../helpers/math'

const ProposalsReport = () => {
  const weekStartDate = dayjs().startOf('week').add(-7, 'day')
  const weekEndDate = dayjs().endOf('week').add(-7, 'day')
  const startDateFormatted = weekStartDate.format('YYYY-MM-DD')
  const endDateFormatted = weekEndDate.format('YYYY-MM-DD')
  const proposalsReportQuery = useGetProposalsReport(startDateFormatted, endDateFormatted)
  const proposalsReport = proposalsReportQuery.data

  const approvedPercentage = roundToPrecision(( (proposalsReport?.totalProposalsApproved ?? 0) / (proposalsReport?.totalProposalsSent ?? 0)) * 100, 2)
  const closeRateWithoutFollowUps = roundToPrecision(((proposalsReport?.totalProposalsApproved ?? 0) - (proposalsReport?.totalProposalFollowUpsSent ?? 0)) / (proposalsReport?.totalProposalsSent ?? 0) * 100, 2)
  const followUpPercentage = roundToPrecision(( (proposalsReport?.totalProposalFollowUpsSent ?? 0) / (proposalsReport?.totalProposalsApproved ?? 0)) * 100, 2)

  if (proposalsReportQuery.isLoading) {
    return <>
      <Skeleton active></Skeleton>
    </>
  }

  return <>
  <Row>
    <Col span={5}>
      Year to Date
    </Col>
  </Row>
    <Card>
      Proposal Summary Data
      <Row gutter={16}>
        <Col span={5}>
          <Card bordered={true}>
            <Statistic title="Total Sent" value={proposalsReport?.totalProposalsSent} />
          </Card>
        </Col>
        <Col span={5}>
          <Card bordered={true}>
          </Card>
        </Col>
        <Col span={5}>
          <Card bordered={true}>
            <Statistic title="Total Sent in Dollars" value={centsToDollarsDisplay(proposalsReport?.totalPriceSent) ?? 0} />
          </Card>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={5}>
          <Card bordered={true}>
            <Statistic title="Total Approved" value={proposalsReport?.totalProposalsApproved} />
          </Card>
        </Col>
        <Col span={5}>
          <Card bordered={true}>
            <Statistic title="Approved Percentage" value={approvedPercentage + '%'} />
          </Card>
        </Col>
        <Col span={5}>
          <Card bordered={true}>
            <Statistic title="Total Approved in Dollars" value={centsToDollarsDisplay(proposalsReport?.totalPriceApproved) ?? 0} />
          </Card>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={5}>
          <Card bordered={true}>
            <Statistic title="Total Approved on Follow Ups" value={proposalsReport?.totalProposalFollowUpsSent} />
          </Card>
        </Col>
        <Col span={5}>
          <Card bordered={true}>
            <Statistic title="Follow Ups Percentage" value={followUpPercentage+ '%'} />
          </Card>
        </Col>
        <Col span={5}>
          <Card bordered={true}>
            <Statistic title="Total Follow Ups in Dollars" value={centsToDollarsDisplay(proposalsReport?.totalPriceFollowUp) ?? 0} />
          </Card>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={5}>
          <Card bordered={true}>
            <Statistic title="Close Rate without Follow Ups" value={closeRateWithoutFollowUps + '%' } />
          </Card>
        </Col>
        <Col span={5}>
          <Card bordered={true}>
            <Statistic title="Close Rate Boost from Follow Ups" value={ roundToPrecision(approvedPercentage - closeRateWithoutFollowUps, 2) + '%'} />
          </Card>
        </Col>
      </Row>
      <Row gutter={16}>
      <Col span={5}>
          <Card bordered={true}>
            Step Approved
            <Table
              columns={[
                {
                  title: 'Step Approved',
                  dataIndex: 'approvedStep',
                  render: (record) => {
                    return 'Follow Up ' + record.approvedStep
                  }
                },
                {
                  title: 'Total Approved',
                  dataIndex: 'total',
                  key: 'total',
                },
                {
                  title: 'Percentage',
                  render: (record) => {
                    return roundToPrecision((record.total / (proposalsReport?.totalProposalsApproved ?? 0)) * 100, 2) + '%'
                  }
                },
                {
                  title: 'Dollars',
                  render: (record) => {
                    return centsToDollarsDisplay(record.dollarAmount)
                  }
                },
              ]}
              dataSource={proposalsReport?.approvedStepWithTotalPrice ?? []}
            />
          </Card>
        </Col>
      </Row>
    </Card>
  </>
}

export default ProposalsReport